import React, { useState, useRef, useEffect } from "react";
import "../../Modules/Topbar/Topbar.css";
import Modal from "@mui/material/Modal";

//images
import rarrow from "../../Assets/svg/rarrow.svg";
import cancel from "../../Assets/svg/cancel.svg";
import locationSvg from "../../Assets/svg/location.svg";
import camera from "../../Assets/png/camera.png";
import { Link, useNavigate } from "react-router-dom";
import { flushSync } from "react-dom";
import { apiCallAdmin, apiCallGeneric } from "../../services/api-service.js";
import moment from "moment";
import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import ProfileImg from "../../Assets/png/user-icon.png";
import { ReactComponent as NavIcon } from "../../Assets/svg/nav-icon.svg";
import Sidebar from "../Sidebar/Sidebar";
import { useGlobal } from "../../GlobalContext.js";
import ProfilePopup from "./ProfilePopup";
import { getOrgLogoApi, getOrgListApi } from "./topbar-api.js";
import apple from "../../Assets/svg/apple.svg";
import android from "../../Assets/svg/android.svg";
import drop from "../../Assets/svg/drop.svg";
import { ReactComponent as HelpIcon } from "../../Assets/svg/faq_ic.svg";
import { ReactComponent as IssueIcon } from "../../Assets/svg/issue_image.svg";
import { ReactComponent as LandingIcon } from "../../Assets/svg/multi_ic.svg";
import ReportAnIssueModal from "../common/report-issue/report-an-issue-model.js";
import QuickTicketModal from "./QuickTicketModal.jsx";
import retake from "../../Assets/svg/retake.svg";
import { X, Camera, CameraOff, Sparkles } from "lucide-react";
const Topbar = ({ selectedTab }) => {
  const isV1 =
    typeof window !== "undefined" &&
    window.location.hostname === "tickgo.v1.mawalog.com";
  const hrmsApiUrl = process.env.REACT_APP_HRMS_API_URL;
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
  const playStoreUrl = process.env.REACT_APP_PLAY_STORE_URL;
  const appleStoreUrl = process.env.REACT_APP_APPLE_STORE_URL;
  const { rolePermissionList, userType } = useGlobal();
  const [open, setOpen] = React.useState(false);
  const [openNotify, setOpenNotify] = React.useState(false);
  const [openProfile, setOpenProfile] = React.useState(false);
  const [openAtten, setOpenAtten] = React.useState(false);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const streamRef = useRef(null);
  const isOpenRef = useRef(false);
  const [image, setImage] = useState(null);
  const [isCameraBlocked, setIsCameraBlocked] = useState(false);
  const navigate = useNavigate();
  const [headerDetails, setHeaderDetails] = useState({});
  const [profileDetails, setProfileDetail] = useState({});
  const [breakList, setBreakList] = useState([]);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [showComplaintModule, setShowComplaintModule] = useState(false);

  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [breaks, setBreaks] = useState("");
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
  const popupRef = useRef();
  const [showPopup, setShowPopup] = useState(false);
  const [showAppPopup, setShowAppPopup] = useState(false);
  const [showQuickTicketDropdown, setShowQuickTicketDropdown] = useState(false);
  const [isDropdownClicked, setIsDropdownClicked] = useState(false);
  const [showQuickTicketModal, setShowQuickTicketModal] = useState(false);
  const quickTicketRef = useRef();
  const [orgLogo, setOrgLogo] = useState("");
  const [orgName, setOrgName] = useState("");
  const [orgList, setOrgList] = useState([]);
  const [firstLetter, setFirstLetter] = useState("");
  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === menuName &&
        element["menu_permission"] === true &&
        element[permission] === true
    ) > -1
      ? true
      : false;
  }
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowAppPopup(false);
      }
      if (quickTicketRef.current && !quickTicketRef.current.contains(event.target)) {
        setShowQuickTicketDropdown(false);
        setIsDropdownClicked(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    getOrgLogo();
    getOrgList();
    getHeaderDetails();
    getProfile();
    getBreakList();
  }, []);

  const getOrgLogo = async () => {
    try {
      const response = await getOrgLogoApi();
      if (response.success === true) {
        setOrgName(response.org_name ?? "....");
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const alertRef = useRef(null);
  const handleClickOutside = React.useCallback((event) => {
    const menuBtn = document.getElementById("mobile-menu-toggle-btn");
    if (menuBtn && menuBtn.contains(event.target)) {
      return;
    }
    if (alertRef.current && !alertRef.current.contains(event.target)) {
      setIsMenuOpen(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("mouseup", handleClickOutside);
    return () => {
      document.removeEventListener("mouseup", handleClickOutside);
    };
  }, [handleClickOutside]);

  const getVideo = () => {
    if (!isOpenRef.current) return;
    if (streamRef.current && streamRef.current.active) {
      if (videoRef.current) {
        videoRef.current.srcObject = streamRef.current;
        videoRef.current.play?.().catch(() => {});
      }
      return;
    }
    navigator.mediaDevices
      ?.getUserMedia({ video: { facingMode: "user" } })
      .then((stream) => {
        if (!isOpenRef.current) {
          stream.getTracks().forEach((track) => {
            track.stop();
            track.enabled = false;
          });
          return;
        }
        streamRef.current = stream;
        if (videoRef.current) {
          videoRef.current.srcObject = stream;
          videoRef.current.play?.().catch(() => {});
        }
      })
      .catch((err) => {
        console.error("Error accessing camera:", err);
      });
  };

  useEffect(() => {
    isOpenRef.current = open;
    if (open) {
      if (!image) {
        getVideo();
      } else {
        stopVideo();
        setIsCameraBlocked(false);
      }
    } else {
      stopVideo();
      setIsCameraBlocked(false);
    }
  }, [open, image]);

  useEffect(() => {
    return () => {
      stopVideo();
    };
  }, []);

  // Real-time camera brightness / closed privacy shutter detector
  useEffect(() => {
    let intervalId;
    if (open && !image) {
      intervalId = setInterval(() => {
        if (videoRef.current && videoRef.current.readyState >= 2) {
          const video = videoRef.current;
          if (video.videoWidth > 0 && video.videoHeight > 0) {
            try {
              const sampleCanvas = document.createElement("canvas");
              sampleCanvas.width = 16;
              sampleCanvas.height = 16;
              const ctx = sampleCanvas.getContext("2d", { willReadFrequently: true });
              if (ctx) {
                ctx.drawImage(video, 0, 0, 16, 16);
                const imgData = ctx.getImageData(0, 0, 16, 16).data;
                let totalLum = 0;
                let maxLum = 0;
                const lumArray = [];
                const totalPixels = 16 * 16;

                for (let i = 0; i < imgData.length; i += 4) {
                  const lum = 0.299 * imgData[i] + 0.587 * imgData[i + 1] + 0.114 * imgData[i + 2];
                  totalLum += lum;
                  lumArray.push(lum);
                  if (lum > maxLum) maxLum = lum;
                }

                const avgLum = totalLum / totalPixels;
                let variance = 0;
                for (const lum of lumArray) {
                  variance += Math.pow(lum - avgLum, 2);
                }
                const stdDev = Math.sqrt(variance / totalPixels);

                // Closed camera shutter / covered lens produces flat sensor noise or dark feed
                const isDark = (avgLum < 35 && stdDev < 8) || (avgLum < 28 && maxLum < 55);
                setIsCameraBlocked(isDark);
              }
            } catch (e) {
              // Ignore canvas read errors if any
            }
          }
        }
      }, 300);
    } else {
      setIsCameraBlocked(false);
    }

    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [open, image]);

  const handleRetake = () => {
    setImage(null);
    setIsCameraBlocked(false);
    setTimeout(() => {
      getVideo();
    }, 50);
  };

  const stopVideo = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => {
        track.stop();
        track.enabled = false;
      });
      streamRef.current = null;
    }
    if (videoRef.current) {
      if (videoRef.current.srcObject) {
        const srcStream = videoRef.current.srcObject;
        if (srcStream.getTracks) {
          srcStream.getTracks().forEach((track) => {
            track.stop();
            track.enabled = false;
          });
        }
        videoRef.current.srcObject = null;
      }
    }
  };
  const onSuccess = (response) => {
    console.log("response", response);
    setSnackbarMessage(response.message ?? "");
    setSnackbarStatus(response.success ?? "");
    handleSnackbarShow();
    setShowComplaintModule(false);
  };
  const handleClose = () => {
    setOpen(false);
    stopVideo();
    setIsCameraBlocked(false);
  };

  const handleOpen = () => {
    setImage(null);
    setOpen(true);
    getLocation();
  };

  const getHeaderDetails = async () => {
    try {
      const response = await apiCallGeneric("get", `${hrmsApiUrl}header_details`);
      if (response?.data?.success === true) {
        setHeaderDetails(response.data.data);
        if (response.data.data.check_in_status) {
          const [hours, minutes, seconds] = response.data.data.duration
            .split(":")
            .map(Number);
          setSecondsElapsed(hours * 3600 + minutes * 60 + seconds);
          if (response.data.data.break_type) {
            const [breakHours, breakMinutes, breakSeconds] =
              response.data.data.break_duration.split(":").map(Number);
            setSecondsElapsedBreak(
              breakHours * 3600 + breakMinutes * 60 + breakSeconds
            );
            setIsRunningBreak(true);
          }
          setIsRunning(true);
        }
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    }
  };
  const getBreakList = async () => {
    try {
      const response = await apiCallGeneric("get", `${hrmsApiUrl}get_break`);
      if (response?.data?.success === true) {
        setBreakList(response.data.breaks);
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    }
  };

  const [secondsElapsed, setSecondsElapsed] = useState(0);
  const [isRunning, setIsRunning] = useState(false);
  useEffect(() => {
    let timerId;
    if (isRunning) {
      timerId = setInterval(() => {
        setSecondsElapsed((prev) => prev + 1);
      }, 1000);
    }
    // Cleanup on component unmount
    return () => clearInterval(timerId);
  }, [isRunning]);

  const [secondsElapsedBreak, setSecondsElapsedBreak] = useState(0);
  const [isRunningBreak, setIsRunningBreak] = useState(false);
  useEffect(() => {
    let timerId;
    if (isRunningBreak) {
      timerId = setInterval(() => {
        if (headerDetails.break_time_exceeded === true) {
          setSecondsElapsedBreak((prev) => prev + 1);
        } else {
          if (secondsElapsedBreak > 0) {
            setSecondsElapsedBreak((prev) => prev - 1);
          } else {
            setSecondsElapsedBreak((prev) => prev + 1);
            if (secondsElapsedBreak === 1) {
              getHeaderDetails();
            }
          }
        }
      }, 1000);
    }
    // Cleanup on component unmount
    return () => clearInterval(timerId);
  }, [isRunningBreak]);

  // Format seconds into HH:MM:SS
  const formatTime = (totalSeconds) => {
    const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
      2,
      "0"
    );
    const seconds = String(totalSeconds % 60).padStart(2, "0");

    return (
      <div
        style={{ display: "flex", alignItems: "center", marginRight: "16px" }}
      >
        <div
          style={{
            width: "40px",
            height: "32px",
            borderRadius: "8px",
            backgroundColor: "#EAEFFF",
            fontSize: "16px",
            fontWeight: "500",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {hours}
        </div>
        <span style={{ paddingLeft: "2px", paddingRight: "2px" }}>:</span>
        <div
          style={{
            width: "40px",
            height: "32px",
            borderRadius: "8px",
            backgroundColor: "#EAEFFF",
            fontSize: "16px",
            fontWeight: "500",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {minutes}
        </div>
        <span style={{ paddingLeft: "2px", paddingRight: "2px" }}>:</span>
        <div
          style={{
            width: "40px",
            height: "32px",
            borderRadius: "8px",
            backgroundColor: "#EAEFFF",
            fontSize: "16px",
            fontWeight: "500",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {seconds}
        </div>
      </div>
    );
  };

  const breakTime = (totalSeconds) => {
    const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(
      2,
      "0"
    );
    const seconds = String(totalSeconds % 60).padStart(2, "0");

    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          marginRight: "16px",
          marginLeft: "16px",
        }}
      >
        <div
          style={{
            width: "40px",
            height: "32px",
            borderRadius: "8px",
            backgroundColor: "#F5F7F9",
            fontSize: "16px",
            fontWeight: "500",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {hours}
        </div>
        <span style={{ paddingLeft: "2px", paddingRight: "2px" }}>:</span>
        <div
          style={{
            width: "40px",
            height: "32px",
            borderRadius: "8px",
            backgroundColor: "#F5F7F9",
            fontSize: "16px",
            fontWeight: "500",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {minutes}
        </div>
        <span style={{ paddingLeft: "2px", paddingRight: "2px" }}>:</span>
        <div
          style={{
            marginRight: "16px",
            width: "40px",
            height: "32px",
            borderRadius: "8px",
            backgroundColor: "#F5F7F9",
            fontSize: "16px",
            fontWeight: "500",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {seconds}
        </div>
      </div>
    );
  };

  const captureImage = () => {
    if (isCameraBlocked) {
      setSnackbarMessage("Camera is closed or covered. Please open the camera shutter.");
      setSnackbarStatus(false);
      handleSnackbarShow();
      return;
    }
    const video = videoRef.current;
    if (!video) return;
    const canvas = canvasRef.current;
    if (!canvas) return;
    const context = canvas.getContext("2d");

    // Set canvas size to match video
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    // Flip the context horizontally for mirror effect
    context.translate(canvas.width, 0);
    context.scale(-1, 1);

    // Draw the video frame on the canvas
    context.drawImage(video, 0, 0, canvas.width, canvas.height);

    // Convert canvas to image URL
    const imageUrl = canvas.toDataURL("image/png");
    setImage(imageUrl);
    // Immediately release camera hardware
    stopVideo();
    setIsCameraBlocked(false);
  };
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  const [locationAddress, setLocationAddress] = useState("");
  const getLocation = () => {
    console.log("getLocation called");
    setLocation({ latitude: null, longitude: null });
    setLocationAddress("");
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log(position.coords.latitude);
          console.log(position.coords.longitude);
          setLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
          getAddress(position.coords.latitude, position.coords.longitude);
        },
        (error) => {}
      );
    } else {
    }
  };
  const getAddress = async (latitude, longitude) => {
    try {
      const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`);
      const data = await response.json();
      setLocationAddress(data.address.state_district + ", " + data.address.state);
    } catch (error) {
      console.error("Error fetching address:", error);
    }
  };

  const breakStartStop = async (id) => {
    const payload = {
      latitude: "",
      longitude: "",
      location: "",
    };
    if (headerDetails.break_type === "") {
      payload["id"] = id;
    }
    const response = await apiCallGeneric(
      "post",
      `${hrmsApiUrl}${
        headerDetails.break_type === "" ? "start_break" : "stop_break"
      }`,
      payload
    );
    if (response?.data?.success === true) {
      getHeaderDetails();
    } else {
      setSnackbarMessage(response?.data?.message ?? "Something went wrong");
      setSnackbarStatus(response?.data?.success ?? false);
      handleSnackbarShow();
    }
  };

  const checkInOut = async () => {
    const response = await apiCallGeneric(
      "post",
      `${hrmsApiUrl}${
        headerDetails.check_in_status === false ? "check_in" : "check_out"
      }`,
      {
        latitude: location.latitude,
        longitude: location.longitude,
        location: locationAddress,
      }
    );
    if (response?.data?.success === true) {
      uploadAttachment(response.data.id);
    } else {
      setSnackbarMessage(response?.data?.message ?? "Something went wrong");
      setSnackbarStatus(response?.data?.success ?? false);
      handleSnackbarShow();
    }
  };
  const uploadAttachment = async (id) => {
    const response = await apiCallGeneric(
      "post",
      `${hrmsApiUrl}${
        headerDetails.check_in_status === false
          ? "check_in_image"
          : "check_out_image"
      }`,
      {
        id: id,
        image: image,
      }
    );
    if (response?.data?.success === true) {
      stopVideo();
      handleClose();
      getHeaderDetails();
    } else {
      setSnackbarMessage(response?.data?.message ?? "Something went wrong");
      setSnackbarStatus(response?.data?.success ?? false);
      handleSnackbarShow();
    }
  };

  const getProfile = async () => {
    try {
      const response = await apiCallAdmin("get", "profile");

      if (response.data.success === true) {
        console.log("booking:", response.data.user);
        setProfileDetail(response.data.user ?? {});
        setFirstLetter(
          response.data.user?.first_name
            ? response.data.user.first_name.charAt(0)
            : ""
        );
      }
    } catch (err) {
      console.error("Error fetching options:", err);
    }
  };
  const getOrgList = async () => {
    console.log("Getting org list");
    const response = await getOrgListApi(28);
    console.log(response.data);
    if (response.status === 200) {
      console.log(response.data.orgs);
      if (response.data.success === true) {
        setOrgList(response.data.orgs ?? []);
      }
    }
  };

  return (
    <>
      {showPopup && (
        <ProfilePopup
          orgList={orgList}
          profileDetail={profileDetails}
          onClose={() => setShowPopup(false)}
          orgLogo={orgLogo}
          orgName={orgName}
          callProfileFunc={getProfile}
        />
      )}
      <div style={{ width: "100%", alignItems: "center" }} className="main2">
        <div
          className="d-flex justify-content-between"
          style={{ alignItems: "center", height: "56px" }}
        >
          <div className="d-flex " style={{ alignItems: "center" }}>
            <div
              id="mobile-menu-toggle-btn"
              onClick={toggleMenu}
              className="d-lg-none d-flex align-items-center justify-content-center"
              style={{
                cursor: "pointer",
                width: "40px",
                height: "40px",
                borderRadius: isMenuOpen ? "50%" : "8px",
                marginRight: "8px",
                transition: "all 0.3s ease",
                position: isMenuOpen ? "fixed" : "static",
                left: isMenuOpen ? "245px" : "auto",
                top: isMenuOpen ? "8px" : "auto",
                zIndex: isMenuOpen ? 1200 : "auto",
                backgroundColor: isMenuOpen ? "#FFFFFF" : "transparent",
                border: isMenuOpen ? "1px solid #E5E5E5" : "none",
                boxShadow: isMenuOpen ? "0 2px 6px rgba(0,0,0,0.15)" : "none",
              }}
              onMouseEnter={(e) => e.currentTarget.style.backgroundColor = isMenuOpen ? "#f5f7f9" : "#f0f2f5"}
              onMouseLeave={(e) => e.currentTarget.style.backgroundColor = isMenuOpen ? "#FFFFFF" : "transparent"}
            >
              {isMenuOpen ? (
                <X size={20} color="#000000" style={{ color: "#000000", stroke: "#000000" }} />
              ) : (
                <NavIcon style={{ width: "20px", height: "20px" }} />
              )}
            </div>
            <div className="dmainmenu2 d-none d-lg-block" onClick={() => navigate("/dashboard")} style={{ cursor: "pointer" }}>
              <p className="mainmenu2">Main Menu</p>
            </div>
            <div className="drarrowimg2 d-none d-lg-block">
              <img src={rarrow} className="rarrowimg2" alt="arrow" />
            </div>
            <div className="dtasks2">
              <p className="tasks2">{selectedTab}</p>
            </div>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "12px", paddingRight: "16px" }}>
            {!isV1 && (
              <button
                type="button"
                className="v1-topbar-btn"
                title="Switch to Tickgo V1.0"
                onClick={() => window.dispatchEvent(new CustomEvent("open-v1-modal"))}
              >
                <Sparkles size={16} className="v1-tag-sparkle" />
                <p className="v1-topbar-text">V1.0</p>
              </button>
            )}

            {headerDetails.check_in_status === true && formatTime(secondsElapsed)}

            {headerDetails.check_in_status === false && (
              <button className="dcheckin2" onClick={handleOpen} style={{ border: "none", margin: 0 }}>
                <p className="pcheckin2">Check-in</p>
              </button>
            )}

            {headerDetails.check_in_status === true && (
              <button className="dcheckout2" onClick={handleOpen} style={{ border: "none", margin: 0 }}>
                <p className="pcheckin2">Checkout</p>
              </button>
            )}

            {headerDetails.check_in_status === true && headerDetails.break_type !== "" && breakTime(secondsElapsedBreak)}

            {headerDetails.check_in_status === true && headerDetails.break_type !== "" && (
              <button
                className="dcheckin2"
                onClick={() => {
                  setBreaks("");
                  setIsRunningBreak(false);
                  breakStartStop("");
                }}
                style={{ border: "none", margin: 0 }}
              >
                <p className="pcheckin2">Stop Break</p>
              </button>
            )}

            {headerDetails.check_in_status === true && headerDetails.break_type === "" && (
              <select
                className="custom-select breakSelect"
                id="breaks"
                value={breaks}
                onChange={(event) => {
                  setBreaks(event.target.value);
                  setIsRunningBreak(true);
                  breakStartStop(event.target.value);
                }}
                style={{
                  fontFamily: "Satoshi",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#212129",
                  height: "40px",
                  borderRadius: "10px",
                  border: "0.7px solid #E5E5E5",
                  backgroundColor: "#FFFFFF",
                  padding: "0 12px",
                  margin: 0,
                }}
              >
                <option value="" disabled hidden>
                  Break
                </option>
                {breakList.map((breakItem, index) => (
                  <option key={index} value={breakItem.value}>
                    {breakItem.label}
                  </option>
                ))}
              </select>
            )}

            {checkPermission("Ticket", "create_permission") && (
              <div
                className="quick-ticket-wrapper"
                ref={quickTicketRef}
                onMouseEnter={() => setShowQuickTicketDropdown(true)}
                onMouseLeave={() => !isDropdownClicked && setShowQuickTicketDropdown(false)}
              >
                <div className="dcreate2" style={{ padding: 0, gap: 0, margin: 0, overflow: "hidden" }}>
                  <div
                    role="button"
                    tabIndex={0}
                    onClick={() => setShowQuickTicketModal(true)}
                    className="nav-link d-flex"
                    style={{
                      padding: "0 16px",
                      height: "100%",
                      alignItems: "center",
                      cursor: "pointer",
                      textDecoration: "none",
                    }}
                  >
                    <p className="pcreate2">+ Quick Ticket</p>
                  </div>
                  <div style={{ width: "1px", height: "100%", background: "#E5E5E5" }}></div>
                  <div
                    style={{
                      padding: "0 12px",
                      cursor: "pointer",
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      const nextState = !isDropdownClicked;
                      setIsDropdownClicked(nextState);
                      setShowQuickTicketDropdown(nextState);
                    }}
                  >
                    <img
                      src={drop}
                      alt="dropdown"
                      style={{
                        width: "10px",
                        filter: "invert(20%) sepia(94%) saturate(4164%) hue-rotate(258deg) brightness(91%) contrast(97%)",
                      }}
                    />
                  </div>
                </div>
                {showQuickTicketDropdown && (
                  <div className="quick-ticket-dropdown">
                    <Link
                      to="/ticket/add"
                      className="dropdown-item"
                    onClick={() => {
                      setShowQuickTicketDropdown(false);
                      setIsDropdownClicked(false);
                    }}
                      style={{
                        textDecoration: "none",
                        color: "#6929E2",
                        fontWeight: "700",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      + Create Ticket
                    </Link>
                  </div>
                )}
              </div>
            )}

            <div className="issue-btn d-none d-md-flex" title="All Applications" onClick={() => window.open(`${accountsUrl}/landing`, "_blank", "noopener,noreferrer")} style={{ margin: 0 }}>
              <LandingIcon />
            </div>

            <div className="issue-btn d-none d-md-flex" title="Report an issue" onClick={() => setShowComplaintModule(true)} style={{ margin: 0 }}>
              <IssueIcon />
            </div>

            <div className="help-btn d-none d-md-flex" onClick={() => navigate("/help")} style={{ margin: 0 }}>
              <HelpIcon />
            </div>

            <div
              onClick={() => setShowPopup(!showPopup)}
              style={{
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                marginLeft: "4px",
              }}
            >
              {profileDetails.profile_image ? (
                <img src={profileDetails.profile_image} style={{ width: "40px", height: "40px", borderRadius: "100px" }} alt="Profile" />
              ) : (
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "100px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    backgroundColor: "#7525B1",
                  }}
                >
                  <div style={{ fontSize: "14px", fontWeight: "700", color: "#FFFFFF" }}>{firstLetter}</div>
                </div>
              )}
            </div>
          </div>
        </div>
        {showComplaintModule && (
          <ReportAnIssueModal
            onSuccess={onSuccess}
            onCancel={() => {
              setShowComplaintModule(false);
            }}
          />
        )}
        <div
          onClick={() => setIsMenuOpen(false)}
          style={{
            position: "fixed",
            left: 0,
            top: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.4)",
            zIndex: 1050,
            opacity: isMenuOpen ? 1 : 0,
            pointerEvents: isMenuOpen ? "auto" : "none",
            transition: "opacity 0.3s ease",
          }}
        />
        <div
          ref={alertRef}
          onClick={(e) => {
            const target = e.target;
            if (target.closest("a, button, img, [role='button']")) {
              setIsMenuOpen(false);
            }
          }}
          style={{
            position: "fixed",
            left: isMenuOpen ? "0" : "-250px",
            top: "0",
            width: "234px",
            height: "100vh",
            zIndex: 1100,
            background: "#fff",
            borderRight: "1px solid #E5E5E5",
            boxShadow: "4px 0px 10px rgba(0,0,0,0.05)",
            transition: "left 0.3s ease",
          }}
        >
          <Sidebar selectedTab={selectedTab} isMobileView={true} />
        </div>
        <ToastContainer position="top-end">
          <Toast
            className="d-inline-block m-1"
            bg={snackbarStatus === true ? "success" : "danger"}
            show={showSnackbar}
            onClose={handleSnackbarClose}
            delay={3000}
            autohide
          >
            {/*  <Toast.Header>
            <strong className="mr-auto">Snackbar Title</strong>
          </Toast.Header> */}
            <Toast.Body style={{ color: "#ffffff" }}>
              {snackbarMessage}
            </Toast.Body>
          </Toast>
        </ToastContainer>
      </div>

      <Modal open={open} onClose={handleClose}>
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "388px",
            minHeight: "566px",
            maxWidth: "94vw",
            maxHeight: "94vh",
            overflowY: "auto",
            backgroundColor: "#FFFFFF",
            padding: "24px",
            borderRadius: "16px",
            boxShadow: "0 10px 40px rgba(0, 0, 0, 0.12)",
            textAlign: "center",
            outline: "none",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "16px",
          }}
        >
          <div
            style={{
              fontFamily: "Satoshi",
              fontWeight: "700",
              fontSize: "16px",
              lineHeight: "22px",
              color: "#212129",
              textAlign: "center",
              width: "100%",
            }}
          >
            Place the face inside the area
          </div>

          {image == null ? (
            <>
              <div
                style={{
                  width: "340px",
                  height: "340px",
                  maxWidth: "100%",
                  aspectRatio: "1/1",
                  position: "relative",
                  boxSizing: "border-box",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "16px",
                    overflow: "hidden",
                    backgroundColor: "transparent",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <video
                    ref={videoRef}
                    autoPlay
                    playsInline
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      transform: "scaleX(-1)",
                      borderRadius: "16px",
                    }}
                  ></video>
                  <canvas ref={canvasRef} style={{ display: "none" }} />
                </div>

                {/* Shutter Closed / Blocked Camera Overlay */}
                {isCameraBlocked && (
                  <div
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      borderRadius: "16px",
                      backgroundColor: "rgba(18, 18, 24, 0.92)",
                      backdropFilter: "blur(4px)",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "24px",
                      boxSizing: "border-box",
                      zIndex: 15,
                      textAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        width: "56px",
                        height: "56px",
                        borderRadius: "50%",
                        backgroundColor: "rgba(105, 41, 226, 0.15)",
                        border: "1.5px solid #6929E2",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        marginBottom: "14px",
                      }}
                    >
                      <CameraOff size={28} color="#BE9BFF" strokeWidth={1.8} />
                    </div>
                    <div
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "700",
                        fontSize: "15px",
                        lineHeight: "20px",
                        color: "#FFFFFF",
                        marginBottom: "6px",
                      }}
                    >
                      Camera is Closed
                    </div>
                    <div
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "400",
                        fontSize: "13px",
                        lineHeight: "18px",
                        color: "#D4DDE7",
                        maxWidth: "240px",
                      }}
                    >
                      Please open your laptop's camera privacy shutter or slider to proceed.
                    </div>
                  </div>
                )}

                {/* Corner Brackets Overlay (Half inside, half outside) */}
                <svg
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    pointerEvents: "none",
                    zIndex: 10,
                    overflow: "visible",
                  }}
                  viewBox="0 0 340 340"
                  fill="none"
                >
                  <path d="M 32 0 H 16 A 16 16 0 0 0 0 16 V 32" stroke="#BE9BFF" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M 308 0 H 324 A 16 16 0 0 1 340 16 V 32" stroke="#BE9BFF" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M 0 308 V 324 A 16 16 0 0 0 16 340 H 32" stroke="#BE9BFF" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M 340 308 V 324 A 16 16 0 0 1 324 340 H 308" stroke="#BE9BFF" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>

              <div
                style={{
                  width: "340px",
                  maxWidth: "100%",
                  minHeight: "48px",
                  borderRadius: "12px",
                  backgroundColor: "#F4EFFF",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  padding: "0 16px",
                  boxSizing: "border-box",
                }}
              >
                <img src={locationSvg} style={{ width: "20px", height: "20px", flexShrink: 0 }} alt="location" />
                <span
                  style={{
                    fontFamily: "Satoshi",
                    fontWeight: "500",
                    fontSize: "14px",
                    lineHeight: "19px",
                    color: "#212129",
                    textAlign: "left",
                    wordBreak: "break-word",
                    overflowWrap: "anywhere",
                    flex: 1,
                  }}
                >
                  {locationAddress || "Loading location..."}
                </span>
              </div>

              <div
                style={{
                  width: "340px",
                  maxWidth: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div
                  onClick={handleClose}
                  style={{
                    cursor: "pointer",
                    width: "44px",
                    height: "44px",
                    borderRadius: "68px",
                    padding: "10px",
                    border: "0.6px solid #D4DDE7",
                    backgroundColor: "#FFFFFF",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxSizing: "border-box",
                  }}
                >
                  <X size={18} color="#091E42" strokeWidth={1.8} />
                </div>

                <div
                  onClick={captureImage}
                  style={{
                    cursor: isCameraBlocked ? "not-allowed" : "pointer",
                    width: "64px",
                    height: "64px",
                    borderRadius: "1000px",
                    border: isCameraBlocked ? "1px solid #D4DDE7" : "1px solid #6929E2",
                    padding: "2px 3px",
                    backgroundColor: "#FFFFFF",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    boxSizing: "border-box",
                    transition: "all 0.15s ease",
                    opacity: isCameraBlocked ? 0.6 : 1,
                  }}
                  title={isCameraBlocked ? "Camera shutter is closed" : "Capture"}
                  onMouseDown={(e) => !isCameraBlocked && (e.currentTarget.style.transform = "scale(0.95)")}
                  onMouseUp={(e) => (e.currentTarget.style.transform = "scale(1)")}
                >
                  <div
                    style={{
                      width: "52px",
                      height: "52px",
                      borderRadius: "50%",
                      backgroundColor: isCameraBlocked ? "#8790A1" : "#6929E2",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Camera size={24} color="#FFFFFF" strokeWidth={2} />
                  </div>
                </div>

                <div
                  onClick={() => {
                    getLocation();
                    if (open) {
                      getVideo();
                    }
                  }}
                  style={{
                    cursor: "pointer",
                    width: "48px",
                    height: "48px",
                    borderRadius: "100px",
                    backgroundColor: "#F5F7F9",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    boxSizing: "border-box",
                  }}
                >
                  <img src={retake} style={{ width: "20px", height: "20px" }} alt="reload" />
                </div>
              </div>
            </>
          ) : (
            <>
              <div
                style={{
                  width: "340px",
                  height: "340px",
                  maxWidth: "100%",
                  aspectRatio: "1/1",
                  position: "relative",
                  boxSizing: "border-box",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "100%",
                    borderRadius: "16px",
                    overflow: "hidden",
                    backgroundColor: "transparent",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={image}
                    alt="Captured"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      borderRadius: "16px",
                    }}
                  />
                </div>

                {/* Corner Brackets Overlay (Half inside, half outside) */}
                <svg
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    pointerEvents: "none",
                    zIndex: 10,
                    overflow: "visible",
                  }}
                  viewBox="0 0 340 340"
                  fill="none"
                >
                  <path d="M 32 0 H 16 A 16 16 0 0 0 0 16 V 32" stroke="#BE9BFF" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M 308 0 H 324 A 16 16 0 0 1 340 16 V 32" stroke="#BE9BFF" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M 0 308 V 324 A 16 16 0 0 0 16 340 H 32" stroke="#BE9BFF" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M 340 308 V 324 A 16 16 0 0 1 324 340 H 308" stroke="#BE9BFF" strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
              </div>

              <div
                style={{
                  width: "340px",
                  maxWidth: "100%",
                  minHeight: "48px",
                  borderRadius: "12px",
                  backgroundColor: "#F4EFFF",
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  padding: "0 16px",
                  boxSizing: "border-box",
                }}
              >
                <img src={locationSvg} style={{ width: "20px", height: "20px", flexShrink: 0 }} alt="location" />
                <span
                  style={{
                    fontFamily: "Satoshi",
                    fontWeight: "500",
                    fontSize: "14px",
                    lineHeight: "19px",
                    color: "#212129",
                    textAlign: "left",
                    wordBreak: "break-word",
                    overflowWrap: "anywhere",
                    flex: 1,
                  }}
                >
                  {locationAddress || "Location captured"}
                </span>
              </div>

              <div
                style={{
                  width: "340px",
                  maxWidth: "100%",
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                }}
              >
                <button
                  type="button"
                  onClick={handleRetake}
                  style={{
                    flex: 1,
                    backgroundColor: "#F5F7F9",
                    color: "#212129",
                    height: "44px",
                    borderRadius: "34px",
                    border: "none",
                    fontFamily: "Satoshi",
                    fontSize: "14px",
                    fontWeight: "700",
                    cursor: "pointer",
                    transition: "background-color 0.2s ease",
                  }}
                >
                  Retake
                </button>

                <button
                  type="button"
                  onClick={checkInOut}
                  style={{
                    flex: 1,
                    backgroundColor: "#6929E2",
                    color: "#FFFFFF",
                    height: "44px",
                    borderRadius: "34px",
                    border: "none",
                    fontFamily: "Satoshi",
                    fontSize: "14px",
                    fontWeight: "700",
                    cursor: "pointer",
                    transition: "background-color 0.2s ease",
                  }}
                >
                  Proceed
                </button>
              </div>
            </>
          )}
        </div>
      </Modal>
      {showQuickTicketModal && (
        <QuickTicketModal
          onHide={() => setShowQuickTicketModal(false)}
          onSuccess={(data) => {
            setShowQuickTicketModal(false);
            const empId = data.emp_id;
            const reporterId = data.reporter_id;
            const assignToId = data.assign_to;

            let targetTab = "tickets";
            if (assignToId === empId) {
              targetTab = "assigned_me";
            } else if (reporterId === empId) {
              targetTab = "my_tickets";
            }

            if (window.location.pathname === "/ticket") {
              navigate("/ticket", { state: { listing_type: targetTab }, replace: true });
            } else {
              navigate("/ticket", { state: { listing_type: targetTab } });
            }
          }}
        />
      )}
    </>
  );
};

export default Topbar;
